module.exports = __webpack_public_path__ + "img/login-back.7f582538.png";